<template>
  <SideNav />
  <Header />
  <div class="card card-body blur shadow-blur mx-0 mx-md-4 mt-n6 overflow-hidden">
    <section
      class="py-4 py-md-6"
      id="news"
    >
      <div class="container px-1">
        <div
          class="col-8 mx-auto text-center mb-5"
        >
          <span class="badge badge-dark mb-2 text-white">NEWS</span>
          <h3>最新消息</h3>
        </div>
        <template v-if="p==1">
          <div class="card card-plain card-blog">
            <div class="row">
              <div 
                class="col-lg-4 col-md-5  position-relative"
                @click="drawPrivateModalPage"
              >
                <div
                  class="nicole-member-center text-warning shadow"
                  style="z-index: 99;cursor: pointer;"
                >
                  <i
                    class="fa-solid fa-circle-play  bg-white rounded-circle"
                    style="font-size: 4rem;"
                  />
                </div>
                <a
                  class="card-image position-relative border-radius-lg"
                  href="javascript:;"
                >
                  <div class="blur-shadow-image ">
                    <img
                      class="img border-radius-lg imgnews"
                      src="@/assets/img/newmap12.png"
                    >
                  </div>
                  <div
                    class="colored-shadow"
                    style="background-image: url(&quot;assets/img/examples/blog-post-1.jpg&quot;);"
                  /></a>
              </div>
              <div class="col-lg-7 col-md-7 mt-4 mt-md-0 ps-sm-4">
                <h5>
                  <a
                    href="javascript:;"
                    @click="goToPage('NewsItem',{nid:12})"
                    class="text-dark"
                  >昀揚科技於2024智慧城市展成功展示「TronMap Metaverse」全方位智慧園區管理解決方案</a>
                </h5> 
                <p>
                  昀揚科技股份有限公司在「2024智慧城市展暨2050淨零城市展」中展示「TronMap Metaverse」全方位智慧園區管理解決方案獲得熱烈關注。<br>
                  <a
                    href="javascript:;"
                    @click="goToPage('NewsItem',{nid:12})"
                    class="text-warning  pt-1"
                  > Read More </a>
                </p>
                <div class="author">
                  <p class="my-auto">
                    2024年3月27日
                  </p>
                  <span class="badge bg-gradient-success ms-2 text-capitalize">創益圖 Tron Map</span>
                </div>
              </div>
            </div>
          </div>

          <div class="card card-plain card-blog mt-5 mt-lg-6">
            <div class="row">
              <div class="col-lg-4 col-md-5">
                <a
                  class="card-image position-relative border-radius-lg"
                  href="javascript:;"
                  @click="goToPage('NewsItem',{nid:11})"
                >
                  <div class="blur-shadow-image ">
                    <img
                      class="img border-radius-lg imgnews"
                      src="assets/img/city2.jpg"
                    >
                  </div>
                  <div
                    class="colored-shadow"
                    style="background-image: url(&quot;assets/img/examples/blog-post-1.jpg&quot;);"
                  /></a>
              </div>
              <div class="col-lg-7 col-md-7 mt-4 mt-md-0 ps-sm-4">
                <h5>
                  <a
                    href="javascript:;"
                    @click="goToPage('NewsItem',{nid:11})"
                    class="text-dark"
                  >昀揚科技攜「TronMap Metaverse」於2024智慧城市展Smart City Summit & Expo展出</a>
                </h5> 
                <p>
                  昀揚科技於2023年10月25日推出「TronMap Metaverse」，將於113年03月19日(四)至03月22日(五)在【2024智慧城市展Smart City Summit & Expo】台北南港展覽館2館 Q202 盛大展出。<br>
                  <a
                    href="javascript:;"
                    @click="goToPage('NewsItem',{nid:11})"
                    class="text-warning  pt-1"
                  > Read More </a>
                </p>
                <div class="author">
                  <p class="my-auto">
                    2024年03月04日
                  </p>
                  <span class="badge bg-gradient-success ms-2 text-capitalize">創益圖 Tron Map</span>
                </div>
              </div>
            </div>
          </div>

          <div class="card card-plain card-blog mt-5 mt-lg-6">
            <div class="row">
              <div class="col-lg-4 col-md-5">
                <a
                  class="card-image position-relative border-radius-lg"
                  href="javascript:;"
                  @click="goToPage('NewsItem',{nid:10})"
                >
                  <div class="blur-shadow-image ">
                    <img
                      class="img border-radius-lg imgnews"
                      src="assets/img/buildg.jpg"
                    >
                  </div>
                  <div
                    class="colored-shadow"
                    style="background-image: url(&quot;assets/img/examples/blog-post-1.jpg&quot;);"
                  /></a>
              </div>
              <div class="col-lg-7 col-md-7 mt-4 mt-md-0 ps-sm-4">
                <h5>
                  <a
                    href="javascript:;"
                    @click="goToPage('NewsItem',{nid:10})"
                    class="text-dark"
                  >北市政府教育局-校舍管理系統，榮獲2023雲端物聯網創新獎之優良應用獎</a>
                </h5> 
                <p>
                  恭賀新北市政府教育局榮獲「2023雲端物聯網創新獎之優良應用獎」，我司與新北市政府教育局合作開發之校舍管理系統為本次參與競賽之亮點平台之一！校舍管理系統為昀揚科技的「創益圖 TronMap」系列產品-「園區建築管理平台系統 ( BMMS Platform Node ) 」授權給新北市政府教育局，於新北市300所學校進行校園平面圖的繪圖、建築物相關資訊連結應用及管理。<br>
                  <a
                    href="javascript:;"
                    @click="goToPage('NewsItem',{nid:10})"
                    class="text-warning  pt-1"
                  > Read More </a>
                </p>
                <div class="author">
                  <p class="my-auto">
                    2023年11月23日
                  </p>
                  <span class="badge bg-gradient-success ms-2 text-capitalize">創益圖 Tron Map</span>
                </div>
              </div>
            </div>
          </div>
          <div class="card card-plain card-blog mt-5 mt-lg-6">
            <div class="row">
              <div class="col-lg-4 col-md-5">
                <a
                  class="card-image position-relative border-radius-lg"
                  href="javascript:;"
                  @click="goToPage('NewsItem',{nid:9})"
                >
                  <div class="blur-shadow-image ">
                    <img
                      class="img border-radius-lg imgnews"
                      src="assets/img/edtech2.jpg"
                    >
                  </div>
                  <div
                    class="colored-shadow"
                    style="background-image: url(&quot;assets/img/examples/blog-post-1.jpg&quot;);"
                  /></a>
              </div>
              <div class="col-lg-7 col-md-7 mt-4 mt-md-0 ps-sm-4">
                <h5>
                  <a
                    href="javascript:;"
                    @click="goToPage('NewsItem',{nid:9})"
                    class="text-dark"
                  >2023教育科技展EdTech Taiwan開展，昀揚科技「TronEdu 創益學」您最佳的教育科技解決方案！</a>
                </h5> 
                <p>
                  昀揚科技股份有限公司於教育科技產業深耕多年，持續研發教育科技解決方案，今年攜「TronEdu 創益學」、「TronMap 創益圖」、「TronSecurity 創益Security」 三大系列產品，於112年11月9日(四)至11月12日(日)在臺北資訊月【臺灣教育科技展】世貿一館盛大展出。<br>
                  <a
                    href="javascript:;"
                    @click="goToPage('NewsItem',{nid:9})"
                    class="text-warning  pt-1"
                  > Read More </a>
                </p>
                <div class="author">
                  <p class="my-auto">
                    2023年11月15日
                  </p>
                  <span class="badge bg-gradient-primary ms-2 text-capitalize">TronEdu創益學</span>
                </div>
              </div>
            </div>
          </div>

          <div class="card card-plain card-blog mt-5 mt-lg-6">
            <div class="row">
              <div class="col-lg-4 col-md-5">
                <a
                  class="card-image position-relative border-radius-lg"
                  href="javascript:;"
                  @click="goToPage('NewsItem',{nid:8})"
                >
                  <div class="blur-shadow-image ">
                    <img
                      class="img border-radius-lg imgnews"
                      src="assets/img/bmms1.jpg"
                    >
                  </div>
                  <div
                    class="colored-shadow"
                    style="background-image: url(&quot;assets/img/bmms1.jpg&quot;);"
                  /><div class="colored-shadow" /></a>
              </div>
              <div class="col-lg-7 col-md-7 mt-4 mt-md-0 ps-sm-4">
                <h5>
                  <a
                    href="javascript:;"
                    @click="goToPage('NewsItem',{nid:8})"
                    class="text-dark"
                  >一眼掌握雲端園區 監控管理好幫手：創益圖Tron Map</a>
                </h5> 
                <p>
                  昀揚科技股份有限公司將於 2024 年 Q1 推出創益圖 Tron Map，
                  近年來掌握「使用者應用生態圈」、透過以人為本的使用者行為與需求，結合智慧科技來創造最高價值的產業紛紛興起，
                  在這一波智慧科技驅動資通訊產業的革命潮流中，
                  為「園區管理」開啟了雲端化的新視野。<br>
                  <a
                    href="javascript:;"
                    @click="goToPage('NewsItem',{nid:8})"
                    class="text-warning  pt-1"
                  > Read More </a>
                </p>
                <div class="author">
                  <p class="my-auto">
                    2023年10月31日
                  </p>
                  <span class="badge bg-gradient-success ms-2 text-capitalize">創益圖 Tron Map</span>
                </div>
              </div>
            </div>
          </div>  
        </template>
        <template v-if="p==2">
          <div class="card card-plain card-blog">
            <div class="row">
              <div class="col-lg-4 col-md-5">
                <a
                  class="card-image position-relative border-radius-lg"
                  href="javascript:;"
                  @click="goToPage('NewsItem',{nid:1})"
                >
                  <div class="blur-shadow-image ">
                    <img
                      class="img border-radius-lg imgnews"
                      src="assets/img/vmware.webp"
                    >
                  </div>
                  <div
                    class="colored-shadow"
                    style="background-image: url(&quot;assets/img/vmware.webp&quot;);"
                  /><div class="colored-shadow" /></a>
              </div>
              <div class="col-lg-7 col-md-7 mt-4 mt-md-0 ps-sm-4">
                <h5>
                  <a
                    class="text-dark"
                    href="javascript:;"
                    @click="goToPage('NewsItem',{nid:1})"
                  >新北市教育局導入VMware Tanzu Greenplum大數據平台，推動智慧教育發展</a>
                </h5> 
                <p>
                  新北市教育局發展智慧教育已行之有年，今年更宣佈啟用全國首座雲端智慧科技中心，並盼能透過大數據力量，極大化校務資料與學習評量等運用效益。在VMware的協助下，新北市教育局採用VMware Tanzu Greenplum作為打造大數據平台的資料分析與軟體管理核心解決方案，並預計自110年起至115年逐步推進四階段導入，驅動教與學的雙軸轉型<br>
                  <a
                    href="javascript:;"
                    @click="goToPage('NewsItem',{nid:1})"
                    class="text-warning  pt-1"
                  > Read More </a>
                </p>
                <div class="author">
                  <p class="my-auto">
                    2023年3月28日
                  </p>
                  <span class="badge bg-gradient-primary ms-2 text-capitalize">TronEdu 創意學</span>
                </div>
              </div>
            </div>
          </div>
        </template>

        <template v-if="p==3">
          3
        </template>
        <div class="pt-5 px-8 text-end">
          <a
            class="btn btn-sm bg-gradient-warning mb-0 me-1"
            href="javascript:;"
            @click="goToPage('news',{p:1})"
          >More News</a>
        </div>
        <!--
        <nav
          aria-label="Page navigation example"
          class="mt-5"
        >
          <ul class="pagination justify-content-center">
            <li class="page-item">
              <a
                class="page-link"
                href="#news"
                v-smooth-scroll
                @click="prevPage()"
              >
                <i
                  class="fa fa-angle-left"
                  aria-hidden="true"
                />
                <span class="sr-only">Previous</span>
              </a>
            </li>

            <li 
              class="page-item"
              :class="{ 'active': p == 1 }"
            >
              <a
                class="page-link"
                :class="{ 'text-white': p == 1 }"
                @click="changePage(1)"
                href="#news"
                v-smooth-scroll
              >1
              </a>
            </li>
            <li
              class="page-item"
              :class="{ 'active': p == 2 }"
            >
              <a
                class="page-link"
                :class="{ 'text-white': p == 2 }"
                @click="changePage(2)"
                href="#news"
                v-smooth-scroll
              >2</a>
            </li>

            <li
              class="page-item"
              :class="{ 'active': p == 3 }"
            >
              <a
                class="page-link"
                :class="{ 'text-white': p == 3 }"
                @click="changePage(3)"
                href="#news"
                v-smooth-scroll
              >3</a>
            </li>
 

            <li class="page-item">
              <a
                class="page-link"
                href="#news"
                v-smooth-scroll
                @click="nextPage()"
              >
                <i
                  class="fa fa-angle-right"
                  aria-hidden="true"
                />
                <span class="sr-only">Next</span>
              </a>
            </li>
          </ul>
        </nav>
        -->
      </div>
    </section>
    <section class="py-4 py-lg-8">
      <div
        class="row"
        data-aos="zoom-in"
        data-aos-easing="linear"
        data-aos-duration="200"
      >
        <div class="col-lg-10 mx-auto bg-gradient-dark border-radius-lg">
          <div class="row py-4 py-md-5 px-3 px-xl-0">
            <div class="col-1 d-none d-xl-block" />  
            <div class="col-xl-2 col-12 px-xl-0 px-3 mb-md-5 my-xl-auto">
              <h3 class="text-white mt-xl-0 mt-3">
                Efficiency 100% +
              </h3>
              <p class="text-white">
                昀揚科技理解您的所有問題，提供使用者更全方位的教育產品，最大化提高工作效率和品質。
              </p>
            </div>      
            <div class="col-1 d-none d-xl-block" />        
            <div class="col-xl-4 col-md-7 z-index-2 position-relative px-md-3 px-3 my-md-auto mt-4">
              <i class="material-icons text-white text-6xl">rate_review</i>
              <p class="text-lg text-white">
                您是否遇到以下問題？
              </p>
              <div class="d-flex">
                <p class="text-lg text-white me-1">
                  Q1.
                </p>
                <p class="text-lg text-white">
                  複雜的題型耗費大量的編輯時間，怎麼辦？
                </p>
              </div>                   
              <div class="d-flex">
                <p class="text-lg text-white me-1">
                  Q2.
                </p>
                <p class="text-lg text-white">
                  拍攝好的課程應該怎麼轉檔和上架？
                </p>
              </div>                   
              <div class="d-flex">
                <p class="text-lg text-white me-1">
                  Q3.
                </p>
                <p class="text-lg text-white">
                  學生使用不同載具，真的能無差別學習嗎？
                </p>
              </div>                   
              <div class="d-flex">
                <p class="text-lg text-white me-1">
                  Q4.
                </p>
                <p class="text-lg text-white">
                  線上系統的資安問題究竟有沒有保障？
                </p>
              </div>                    
              <div class="d-flex">
                <p class="text-lg text-white me-1">
                  Q5.
                </p>
                <p class="text-lg text-white">
                  能不能不要侷限在同一地點處理編輯工作？
                </p>
              </div>
            </div>
           
            <div class="col-xl-4 col-md-5 px-lg-5 position-relative">
              <img
                class="img border-radius-md max-width-300 w-100 position-relative z-index-2 mt-xl-n7"
                src="assets/img/work.jpg"
              >
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="py-4 py-md-6">
      <div
        class="container"
        data-aos="fade-up"
        data-aos-delay="200"
        data-aos-duration="300"
      >
        <div class="text-center">
          <span class="badge badge-dark mb-2 text-white">Solution</span>
          <h3>產品的前瞻佈局</h3>
        </div>
        <div class="row mt-3 mt-lg-7">
          <div class="col-sm-6 col-lg-4 mt-lg-5 mt-4 text-center">
            <a 
              class="page-link"
              href="#RAO"
              v-smooth-scroll
              @click="goToPage('Company#ROA')"
            >
              <img
                class="width-32-px mb-4"
                src="assets/img/08.png"
                style="width: 110px;"
              >
              <h5>RAO 技術</h5>
              <p>
                改善大型網路應用平台在環境嚴苛且複雜問題，
                透過各種演算法大幅降低資料錯誤問題，
                提供高可用性及可靠性的應用服務。
              </p>
            </a>
          </div>
          <div class="col-sm-6 col-lg-4 mt-lg-5 mt-4 text-center">
            <a 
              class="page-link"
              href="#K8S"
              v-smooth-scroll
              @click="goToPage('Company#K8S')"
            >
              <img
                class="width-32-px mb-4"
                src="assets/img/04.png"
                style="width: 110px;"
              >
              <h5>Container 容器化架構</h5>
              <p>
                全面採用容器化微服務架構，使系統具備高度的整合擴展性，在各種復雜的 IT 使用情境和整合需求下有著最活潑的解決方案。
              </p>
            </a>
          </div>
          <div class="col-sm-6 col-lg-4 mt-lg-5 mt-4 text-center">
            <img
              class="width-32-px mb-4"
              src="assets/img/03.png"
              style="width: 110px;"
            >
            <h5>安全性</h5>
            <p>符合 OWASP 2021 安全標準、工業局 L2 L3 安全規範</p>
          </div>
          <div class="col-sm-6 col-lg-4 mt-lg-5 mt-4 text-center">
            <a 
              class="page-link"
              href="#SMDN"
              v-smooth-scroll
              @click="goToPage('CRStream#SMDN')"
            >
              <img
                class="width-32-px mb-4"
                src="assets/img/10.png"
                style="width: 110px;"
              >
              <h5>SMDN 影音串流技術</h5>
              <p>
                Streaming Media Distribution Network 獨家專利技術，
                自動優化串流媒體服務的播放品質，將效能提升至最佳化，使高頻寬的應用服務（高畫質影片）更加順暢。
              </p>
            </a>
          </div>
          <div class="col-sm-6 col-lg-4 mt-lg-5 mt-4 text-center">
            <a 
              class="page-link"
              href="#EXAM"
              v-smooth-scroll
              @click="goToPage('TronEdu#EXAM')"
            >

              <img
                class="mb-4"
                src="assets/img/09.png"
                style="width: 110px;"
              >
              <h5>跨載具命題系統</h5>
              <p>
                獨家「跨載具命題系統」專利技術，
                解決小學、國中、高中的全科、全版編輯及全載具解析度問題。
                採用 Microsoft Word 編輯工具，
                大幅度降低整合風險及成本。
              </p>
            </a>
          </div>
          <div class="col-sm-6 col-lg-4 mt-lg-5 mt-4 text-center">
            <a 
              class="page-link"
              href="#K8S"
              v-smooth-scroll
              @click="goToPage('Company#K8S')"
            >

              <img
                class="width-32-px mb-4"
                src="assets/img/01.png"
                style="width: 110px;"
              >
              <h5>Depolyment 快速部署</h5>
              <p>
                一處開發全載具可佈署，
                全系列產品採用 Kubernetes ( K8S ) 來管理微服務，您可以輕鬆並且高效的部署容器與各種服務。
                節省您大量的管理成本。
              </p>
            </a>
          </div>
        </div>
      </div>
    </section>
    <section
      class="bg-gradient-dark position-relative overflow-hidden mt-5 mx-n3"
      data-aos="zoom-in"
      data-aos-easing="linear"
      data-aos-duration="400"
    >
      <img
        src="assets/img/shapes/waves-white.svg"
        alt="pattern-lines"
        class="position-absolute opacity-1 w-100 h-100"
        style="object-fit: cover;"
      >
      <div class="container py-lg-6 py-2">
        <div class="row">
          <div class="col-lg-6 d-flex justify-content-center flex-column">
            <div
              id="carouselExampleIndicator"
              class="carousel slide pt-5 pb-7 py-lg-7"
              data-bs-ride="carousel"
            >
              <div class="carousel-indicators justify-content-start ms-0">
                <!--
              <a href="javascript:;">
                <img src="assets/img/01.png" class="avatar avatar-sm avatar-scale-up border-radius-lg shadow border-0 active" data-bs-target="#carouselExampleIndicator" data-bs-slide-to="0">
                <span class="text-white mx-2">&#124;</span>
              </a>
-->
                <!--
              <a href="javascript:;">
                <img src="assets/img/09.png" class="avatar avatar-sm avatar-scale-up border-radius-lg shadow border-0" data-bs-target="#carouselExampleIndicator" data-bs-slide-to="1">
                <span class="text-white mx-2">&#124;</span>
              </a>
              <a href="javascript:;">
                <img src="assets/img/10.png" class="avatar avatar-sm avatar-scale-up border-radius-lg shadow border-0" data-bs-target="#carouselExampleIndicator" data-bs-slide-to="2">
              </a>
-->
              </div>
              <div class="carousel-inner">
                <h2 class="text-white">
                  產品專利
                </h2>
                <p class="text-white opacity-8 mb-1">
                  專屬於昀揚科技的新型發明，提供最完整的產品服務
                </p>
                <hr class="text-white horizontal opacity-6 mb-4 mt-2 w-25 text-start">
                <div class="carousel-item active">
                  <h6 class="text-white pe-5">
                    coming soon
                  </h6>
                  <h6 class="text-white pe-5">
                    敬請期待
                  </h6>
                  <div class="author mt-4">
                    <div class="name">
                      <!--
                      <span class="text-white">台灣新型</span>
                      <div class="stats">
                        <small class="text-white opacity-6">2023</small>
                      </div>
                      -->
                    </div>
                  </div>
                </div>
                <!--
              <div class="carousel-item">
                <h6 class="text-white pe-5">學力診斷系統</h6>
                <h6 class="text-white pe-5">根據教育部十二年國民基本教育課程綱要指出，學習重點包含「學習表現」與「學習內容」兩部分，提供課程設計、教材發展、教科書審查及學習評量的架構，並配合教學加以實踐。</h6>
                <div class="author mt-4">
                  <div class="name">
                    <span class="text-white">台灣新型</span>
                    <div class="stats">
                      <small class="text-white opacity-6">2023</small>
                    </div>
                  </div>
                </div>
              </div>
              <div class="carousel-item">
                <h6 class="text-white pe-5">學力診斷系統</h6>
                <h6 class="text-white pe-5">根據教育部十二年國民基本教育課程綱要指出，學習重點包含「學習表現」與「學習內容」兩部分，提供課程設計、教材發展、教科書審查及學習評量的架構，並配合教學加以實踐。</h6>
                <div class="author mt-4">
                  <div class="name">
                    <span class="text-white">台灣新型</span>
                    <div class="stats">
                      <small class="text-white opacity-6">2023</small>
                    </div>
                  </div>
                </div>
              </div>
-->
              </div>
            </div>
          </div>
          <div class="col-md-6 justify-content-center flex-column d-sm-none d-md-none d-lg-flex d-xl-flex ">
            <img
              src="assets/img/test1-1.png"
              class="img-fluid my-4 mt-md-0"
            >
          </div>
        </div>
      </div>
    </section>


    <section
      class="pt-lg-9 pt-lg-7  py-6"
      id="count-stats"
      data-aos="zoom-in"
      data-aos-easing="linear"
      data-aos-duration="600"
    >
      <div class="container">
<!--
        <div class="row">
          <div class="col-lg-6 mx-auto text-center">
            <span class="badge badge-dark mb-2 text-white">CLIENTS</span>
            <h3 class="mb-3">
              合作伙伴
            </h3>
            <p>昀揚科技多年深耕資訊領域，專注於教育科技、園區管理、資訊安全等產品研發與應用。</p>
          </div>
        </div>
        
        <hr class="horizontal dark my-5">


        <div class="row align-items-center">
          <div class="col-xl-3 col-lg-3 col-md-4 col-6 mb-5">
            <img
              src="assets/img/edu.png"
              class="iconlogo"
            >
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-6 mb-5">
            <img
              src="assets/img/lt.png"
              class="iconlogo"
            >
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-6 mb-5">
            <img
              src="assets/img/metmge.png"
              class="iconlogo"
            >
          </div>          
          <div class="col-xl-3 col-lg-3 col-md-4 col-6 mb-5">
            <img
              src="assets/img/authen.png"
              class="iconlogo"
            >
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-6 mb-5">
            <img
              src="assets/img/tact.png"
              class="iconlogo"
            >
          </div>  
          <div class="col-xl-3 col-lg-3 col-md-4 col-6 mb-5">
            <img
              src="assets/img/sb.png"
              class="iconlogo"
            >
          </div>  
          <div class="col-xl-3 col-lg-3 col-md-4 col-6 mb-5">
            <img
              src="assets/img/ocean.png"
              class="iconlogo"
            >
          </div>
        </div>
-->
        <hr class="horizontal dark my-2">    
        <div class="row justify-content-center text-center mt-5">
          <div class="col-md-3">
            <h1
              class="text-gradient text-warning"
              id="state1"
              countTo="681"
            >
              0
            </h1>
            <h5>Schools</h5>
            <p>使用我們產品的學校或教育機構</p>
          </div>
          <div class="col-md-3">
            <h1 class="text-gradient text-warning">
              <span
                id="state2"
                countTo="293"
              >0</span>K+
            </h1>
            <h5>Users</h5>
            <p>使用我們產品的使用者</p>
          </div>
          <div class="col-md-3">
            <h1 class="text-gradient text-warning">
              <span
                id="state3"
                countTo="31"
              >0</span>/<span
                id="state4"
                countTo="30"
              >0</span>
            </h1>
            <h5>Patents</h5>
            <p>我們申請的專利/商標</p>
          </div>
        </div>
      </div>
    </section>
  </div>
  <PrivateModalPage
    :privatePkyId="privatePkyId"
  />
  <Footer />
</template>
<script>
/* eslint-disable import/no-absolute-path */
// eslint-disable-next-line import/no-unresolved
import { config, crstream } from '@/include/config';
import {
  h,
  ref,
  toRefs,
  reactive,
  watch,
  inject,
  onMounted,
  onBeforeUpdate,
  onUpdated
} from 'vue';
import { oltConsole, oAA , oAuth, oApiError , oFrame } from '@/lib/oltModule/initOltVue3';
//import Header from '@/components/Header.vue';
import { SideNav , Header , Footer } from '@/components/Frame';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { PrivateModalPage } from '@/components/Preview' ;

export default {
  name: 'App',
  components: {
    SideNav,
    Header,
    //NavBar,
    // Settings,
    Footer,
    PrivateModalPage,
  },
  setup() {

    /**
     *  swal start
     */
    const swal = inject('$swal');
    /**
     *  swal end
     */

    const router = useRouter();
    const route = useRoute();
    const store = useStore();


    /**
     * Change Page Start
     */
    const p = ref();
    //console.log('router.currentRoute.value : ', router.currentRoute.value.query);

    if(router.currentRoute.value.query.p == null || router.currentRoute.value.query.p == '' ){
      /*
      swal.fire({
        icon:'error',
        html:'路徑錯誤！！',
        buttonsStyling: true,
        confirmButtonClass: 'md-button md-success',
        //confirmButtonText:t('messages.confirm_button'),
      }).then( result => {
        if (result.value) {
          //console.log('result : ' , result);
          //emit('addCallBack');
          //router.go(-1);
          goToPage('/');
        }
      });
      */
      p.value= 1 ; 
    }
    else{
      p.value= router.currentRoute.value.query.p ; 
    }
    //console.log('p',p.value);
    function changePage(item) {
      //console.log('changePage : ' , p);
      p.value = item ; 
    }
    function nextPage() {
      if(p.value == 2 ){
        p.value == 2;
      }
      else{
        p.value = p.value + 1;
      }
    }
    function prevPage() {
      if(p.value == 1 ){
        p.value == 1;
      }
      else{
        p.value = p.value - 1;
      }
    }
    /**
     * Change Page End
     */


    onMounted(async () => {
      chkLogin();
    });
    // Reload MDInput End

    onUpdated(async () => {
      // 修改 VUE 時 必需全部強制關閉 Modals 
      // eslint-disable-next-line no-undef
      //await oAdminFrame.closeAllModals() ;
    }) ;

    function goToPage(pageItem,queryItem){
      if(router.currentRoute.value.name == pageItem) { return; }
      //router.push(page);
      //router.push({ path:'Home' , query:{page:1,blid:1}} );
      //console.log('pageItem : ', pageItem);
      router.push({ path:pageItem , query:queryItem} );
    }
    

    function chkLogin(){
      let isLogin = oAuth.isLogin(store);

      if(!isLogin){
        //router.push({ path: '/AuthPage/SignIn' });
      }
    }

    const privatePkyId = ref('0');
    const currentProtocol = window.location.protocol;
    const urlKey = ref(currentProtocol == 'http:' ? 'url' : 'urls');
    const demoVideo = ref();

    function drawPrivateModalPage(){
      privatePkyId.value = demoVideo.value[urlKey.value] ;
	  
      	// console.log("privatePkyId");
      	// console.log(privatePkyId.value );
	
      // eslint-disable-next-line no-undef
      $('#private').modal('show');
    }

    function guestLogin(){

      const apiParam = {
          restApiDriver: config.crStreamApiDriver ,// token key from veex store 
          // auth
          token: "",
          // Debug Mode 
          apiPostDebug: false, // API 新增 除錯模式
          apiName: "admin_guest_login",
          form: {
              id: crstream.id,
              secret: crstream.secret,
              domain: "",
          },
      };
      //console.log('apiParam : ', apiParam);
      let resObj = oAA.postRecordVue3(apiParam);
      resObj.then((res) => {
          //console.log('res : ', res);
          if (res["admin_guest_login"] && res["admin_guest_login"]['tokens'] && res["admin_guest_login"]['tokens']['token']) {
            getVideo(res["admin_guest_login"]['tokens']['token'], crstream.id, crstream.secret, "", "N");
          }
      }).catch((exception) => {
          console.log("exception : " + exception);
          // console.log(err.response.data);
      });
    }

    function getVideo(token, id, secret, account, isPrivate) {
        const apiParam = {
            restApiDriver: config.crStreamApiDriver ,// token key from veex store 
            // auth
            token: token, // token key from veex store 
            // Debug Mode 
            apiGetPageDebug: false, // API getPageRecord 除錯模式
            apiGetRtAllRecordDebug: false, // rtAllRecord Debug 
            apiGetRtPageRecordDebug: false, // API getRt 除錯模式        
            // API Filter 
            apiName: 'video_custom',
            pageNumber: 1, // int32 
            pageSize: 10, // int 32
            pageSort: 'seq', // string 
            pageSortBy: 'asc', // string 
            customFilter: false,
            pageSearch: {
                vid: 51,
            }, // json format 
            pageGroup: '', // string 
            pageGroupBy: '', // string 
            pageMode: true, // 是否打開換頁邏輯，若設定 fale 則預設只抓 1000 筆，參考 FunsController.php 。
            module: "", // module 
            fun: "video", // fun 
            act: 'view', // act  
            // rt 
            rtSet: {},
            queueSpeed: 1, // 異步 IO queue 的 順序執行間隔時間 1/1000 秒
        };
        oAA.queueGetAllVue3(apiParam)
            .then(
                res => {
                    if (res.pageRecord && res.pageRecord.data && res.pageRecord.data.length > 0) {
                        demoVideo.value = res.pageRecord.data[0];
                        //videoSrc.value = res.pageRecord.data[0][urlKey.value];
                        postVideoLinkHistory(token, {
                            vid: res.pageRecord.data[0]["vid"],
                            video_name: res.pageRecord.data[0]["name"],
                            id: id,
                            secret: secret,
                            account: account,
                            get_video_time: moment(Date.now()).format('YYYY-MM-DD HH:mm:ss'),
                            year: moment(Date.now()).format('YYYY'),
                            month: moment(Date.now()).format('MM'),
                            day: moment(Date.now()).format('DD'),
                            hour: moment(Date.now()).format('HH'),
                            min: moment(Date.now()).format('mm'),
                        });
                    }
                }
            )
            .catch((err) => {
                oApiError.chkError(err, swal, t);
                //console.log(err);
            });
    }

        function postVideoLinkHistory(token, form){
            //console.log("[postVideoLinkHistory] form: ", form);
            const apiParam = {
                restApiDriver: config.crStreamApiDriver ,// token key from veex store 
                // auth
                token: token,
                // Debug Mode 
                apiPostDebug: false, // API 新增 除錯模式
                apiName: "video_link_history",
                form: form,
                fun: "VideoLinkHistory", // fun 
                act: 'view', // act 
            };
            let resObj = oAA.postRecordVue3(apiParam);
            resObj.then((res) => {
                //console.log('res : ', res);
            }).catch((exception) => {
                //console.log("exception : " + exception);
                //console.log(exception.response.data);
            });
        }
    guestLogin();



    return {
      hiddenHeader:false,
      // api setting
      setDebugMode: true,
      apiDebug: false,
      apiName: '',
      perPage: 3, //筆數
      pageMode: true,
      perPageOptions: [5, 10, 25, 50, 75, 100],
      // data
      userInfo:{coin:0 , point:0},
      token:null,
      p,
      privatePkyId,
      // function
      goToPage,
      chkLogin,
      changePage,
      nextPage,
      prevPage,
      drawPrivateModalPage
    };
  },
  created() {
  },
  mounted() {
    oFrame.initMD();
  },
  methods: {
  }
};
</script>
<style scoped>
.nicole-member-center :hover{
  transform: scale(1.2);
  transition: 0.5s;
}
</style>
